import React from 'react';
import Icon from '@/components/ui/AppIcon';

const LocationMap = () => {
  const latitude = 40.2206;
  const longitude = -74.7597;

  return (
    <div className="rounded-xl bg-card p-6 shadow-warm">
      <div className="mb-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Icon name="MapIcon" size={24} className="text-primary" />
          <h3 className="font-heading text-lg font-semibold text-foreground">
            Our Location
          </h3>
        </div>
        <a
          href={`https://maps.google.com/?q=${latitude},${longitude}`}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 rounded-md bg-primary/10 px-4 py-2 text-sm font-medium text-primary transition-smooth hover:bg-primary hover:text-primary-foreground"
        >
          <Icon name="ArrowTopRightOnSquareIcon" size={16} />
          Get Directions
        </a>
      </div>

      <div className="overflow-hidden rounded-lg">
        <div className="relative h-[400px] w-full bg-muted">
          <iframe
            width="100%"
            height="100%"
            loading="lazy"
            title="LuminexLabradors Breeder Location"
            referrerPolicy="no-referrer-when-downgrade"
            src={`https://www.google.com/maps?q=${latitude},${longitude}&z=14&output=embed`}
            className="border-0"
          />
        </div>
      </div>

      <div className="mt-4 rounded-md bg-muted p-4">
        <p className="mb-2 flex items-start gap-2 text-sm text-foreground">
          <Icon name="InformationCircleIcon" size={20} className="shrink-0 text-primary" />
          <span>
            <strong>Visit by Appointment Only:</strong> Please schedule your visit in advance to ensure we can provide you with personalized attention and allow you to meet our available puppies.
          </span>
        </p>
      </div>
    </div>
  );
};

export default LocationMap;